{
  "grid": {
    "reorderBlocked": {
      "sort": "Retirez le tri pour réordonner les lignes",
      "search": "Effacez la recherche pour réordonner les lignes"
    },
    "empty": {
      "noColumns": "Ce tableau n'a aucune colonne.",
      "noColumnsYet": "Ce tableau n'a pas encore de colonne.",
      "noRows": "Aucune ligne.",
      "noRowsYet": "Pas encore de ligne.",
      "noMatch": "Aucune ligne ne correspond à la recherche ou aux filtres."
    },
    "addColumn": "Ajouter une colonne",
    "selectAll": "Sélectionner toutes les lignes",
    "clearSelection": "Effacer la sélection",
    "newRow": "Nouvelle ligne",
    "newRowClearsView": "Nouvelle ligne — réinitialise la vue",
    "dragToReorder": "Faites glisser pour réordonner",
    "selectRow": "Sélectionner la ligne",
    "openRow": "Ouvrir la ligne"
  },
  "toolbar": {
    "searchPlaceholder": "Rechercher…",
    "clearSearch": "Effacer la recherche",
    "rowHeight": "Hauteur des lignes",
    "filteredCount": "{{visible}} sur {{total}}"
  },
  "rowCount": {
    "exact_one": "{{count}} ligne",
    "exact_other": "{{count}} lignes",
    "partial": "{{count}}+ lignes"
  },
  "rowHeights": {
    "short": "Basse",
    "medium": "Moyenne",
    "tall": "Haute",
    "full": "Complète"
  },
  "columnMenu": {
    "description": "Description",
    "descriptionPlaceholder": "Ce que contient cette colonne. Visible par Nolë et dans la fiche.",
    "columnType": "Type de colonne",
    "clearsCells_one": "Efface {{count}} cellule",
    "clearsCells_other": "Efface {{count}} cellules",
    "namePlaceholder": "Nom de la colonne",
    "optionsAndSettings": "Options et réglages",
    "sortAsc": "Trier de A à Z",
    "sortDesc": "Trier de Z à A",
    "clearSort": "Retirer le tri",
    "deleteColumn": "Supprimer la colonne"
  },
  "fieldTypes": {
    "text": "Texte",
    "rich_text": "Texte long",
    "number": "Nombre",
    "checkbox": "Case à cocher",
    "select": "Sélection",
    "multi_select": "Sélection multiple",
    "status": "Statut",
    "date": "Date",
    "url": "URL",
    "email": "E-mail",
    "phone": "Téléphone",
    "file": "Fichiers",
    "node": "Node",
    "relation": "Relation",
    "created_time": "Date de création",
    "updated_time": "Dernière modification"
  },
  "filters": {
    "button": "Filtrer",
    "empty": "Aucun filtre pour l'instant.",
    "where": "Où",
    "and": "Et",
    "or": "Ou",
    "deletedColumn": "Colonne supprimée",
    "group_one": "Un groupe de {{count}} condition",
    "group_other": "Un groupe de {{count}} conditions",
    "remove": "Retirer le filtre",
    "add": "Ajouter un filtre",
    "clearAll": "Tout effacer",
    "optionPlaceholder": "Option",
    "dayPlaceholder": "2026-10-23, aujourd'hui…",
    "valuePlaceholder": "Valeur"
  },
  "operators": {
    "is_empty": "est vide",
    "is_not_empty": "n'est pas vide",
    "eq": "est",
    "neq": "n'est pas",
    "contains": "contient",
    "not_contains": "ne contient pas",
    "starts_with": "commence par",
    "ends_with": "se termine par",
    "gt": ">",
    "gte": "≥",
    "lt": "<",
    "lte": "≤",
    "is_any_of": "est l'un de",
    "is_none_of": "n'est aucun de",
    "has_all_of": "contient tous",
    "before": "est avant le",
    "after": "est après le",
    "on_or_before": "est le ou avant le",
    "on_or_after": "est le ou après le",
    "is_checked": "est cochée",
    "is_unchecked": "n'est pas cochée",
    "is_done": "est terminé",
    "is_not_done": "n'est pas terminé"
  },
  "summaries": {
    "calculate": "Calculer",
    "count": "Tout compter",
    "count_empty": "Vides",
    "count_not_empty": "Remplies",
    "count_unique": "Uniques",
    "percent_empty": "% vides",
    "percent_not_empty": "% remplies",
    "sum": "Somme",
    "average": "Moyenne",
    "median": "Médiane",
    "min": "Min",
    "max": "Max",
    "range": "Étendue",
    "count_checked": "Cochées",
    "count_unchecked": "Non cochées",
    "percent_checked": "% cochées",
    "percent_unchecked": "% non cochées",
    "earliest": "Plus ancienne",
    "latest": "Plus récente"
  },
  "bulk": {
    "toolbarLabel": "Lignes sélectionnées",
    "selected_one": "{{count}} ligne sélectionnée",
    "selected_other": "{{count}} lignes sélectionnées",
    "editField": "Modifier un champ",
    "dialogTitle_one": "Modifier {{count}} ligne",
    "dialogTitle_other": "Modifier {{count}} lignes",
    "dialogDescription": "La valeur remplace celle de chaque ligne sélectionnée. Laissée vide, elle l'efface.",
    "chooseField": "Choisissez un champ",
    "applyTo_one": "Appliquer à {{count}} ligne",
    "applyTo_other": "Appliquer à {{count}} lignes"
  },
  "record": {
    "title": "Ligne {{index}} <muted>sur {{total}}</muted>",
    "description": "Tous les champs de cette ligne, en pleine largeur.",
    "previous": "Ligne précédente",
    "next": "Ligne suivante",
    "deleteRow": "Supprimer la ligne"
  },
  "import": {
    "emptyFile": "Ce fichier CSV est vide ou n'a pas de ligne d'en-tête.",
    "readError": "Impossible de lire le fichier",
    "title": "Importer un CSV",
    "pickDescription": "Choisissez un fichier CSV pour commencer.",
    "mapDescription": "Vérifiez comment les colonnes du CSV correspondent à ce tableau.",
    "changeFile": "Changer de fichier",
    "confirm": "Importer",
    "confirmWithCount_one": "Importer ({{count}} ligne)",
    "confirmWithCount_other": "Importer ({{count}} lignes)",
    "dropzone": "Déposez un fichier CSV ici, ou cliquez pour parcourir.",
    "preview_one": "Aperçu ({{count}} première ligne)",
    "preview_other": "Aperçu ({{count}} premières lignes)",
    "emptyHeader": "(vide)",
    "mapping": "Correspondance des colonnes",
    "csvColumn": "Colonne du CSV",
    "target": "Destination",
    "type": "Type",
    "unnamedColumn": "(colonne {{index}})",
    "newColumn": "+ Nouvelle colonne",
    "skip": "Ignorer",
    "mode": "Mode d'import",
    "append": "Ajouter aux lignes existantes",
    "replace": "Remplacer le tableau"
  },
  "fieldSettings": {
    "placeholder": "Texte indicatif",
    "showAs": "Afficher comme",
    "display": "Affichage",
    "auto": "Auto",
    "text": {
      "maxLength": "Longueur maximale",
      "wrap": "Retour à la ligne dans le tableau",
      "wrapHint": "Afficher tout le texte au lieu d'une seule ligne"
    },
    "checkbox": {
      "toggle": "Interrupteur",
      "label": "Libellé",
      "labelHint": "Affiché à côté de la case"
    },
    "number": {
      "formatGroup": "Format",
      "format": "Format",
      "percent": "Pourcentage",
      "currency": "Devise",
      "currencyHint": "Code ISO : EUR, USD, GBP…",
      "currencyDisplay": "Afficher la devise comme",
      "currencySymbol": "Symbole (€)",
      "currencyCode": "Code (EUR)",
      "currencyName": "Nom (euros)",
      "currencyPosition": "Position de la devise",
      "automatic": "Automatique",
      "before": "Avant",
      "after": "Après",
      "unit": "Unité",
      "unitHint": "kg, h, km…",
      "unitPosition": "Position de l'unité",
      "decimals": "Décimales",
      "thousandsSeparator": "Séparateur de milliers",
      "abbreviate": "Abréger",
      "abbreviateHint": "1,2 k, 3,4 M",
      "range": "Plage",
      "minimum": "Minimum",
      "maximum": "Maximum",
      "bar": "Barre",
      "ring": "Anneau",
      "slider": "Curseur",
      "color": "Couleur",
      "showValue": "Afficher le nombre",
      "step": "Pas"
    },
    "choice": {
      "options": "Options",
      "behavior": "Comportement",
      "sort": "Trier les options",
      "manual": "Manuellement",
      "alphabetical": "Par ordre alphabétique",
      "allowCreate": "Créer des options en tapant",
      "pill": "Pastille de couleur"
    },
    "status": {
      "statuses": "Statuts",
      "groupName": "Nom du groupe",
      "add": "Ajouter un statut",
      "groups": {
        "todo": "À faire",
        "in_progress": "En cours",
        "done": "Terminé"
      }
    },
    "url": {
      "full": "Adresse complète",
      "domain": "Domaine",
      "title": "Titre de la page"
    },
    "phone": {
      "defaultCountry": "Pays par défaut",
      "defaultCountryHint": "Pour les numéros saisis sans +",
      "country": "{{country}} ({{dialCode}})"
    },
    "date": {
      "relative": "Relative (dans 3 jours)",
      "dateFormat": "Format de date",
      "shortExample": "23/10/2026",
      "mediumExample": "23 oct. 2026",
      "longExample": "vendredi 23 octobre 2026",
      "timeFormat": "Format de l'heure",
      "value": "Valeur",
      "includeTime": "Inclure l'heure",
      "endDate": "Date de fin",
      "endDateHint": "Une période : du… au…"
    },
    "file": {
      "accepted": "Fichiers acceptés",
      "acceptedHint": "Aucun coché : tous les fichiers",
      "categories": {
        "image": "Images",
        "pdf": "PDF",
        "audio": "Audio",
        "video": "Vidéo",
        "other": "Autres fichiers"
      },
      "multiple": "Plusieurs fichiers",
      "maxSize": "Taille maximale (Mo)",
      "thumbnails": "Miniatures",
      "list": "Noms des fichiers",
      "cover": "Image de couverture"
    },
    "node": {
      "any": "Tous les nodes",
      "type": "Type de node",
      "multiple": "Plusieurs nodes"
    },
    "choose": "Choisir…",
    "relation": {
      "untitledDatabase": "Base de données sans titre",
      "unavailableDatabase": "Base de données indisponible",
      "database": "Base de données",
      "multiple": "Plusieurs lignes",
      "twoWay": "Bidirectionnelle",
      "twoWayOnNamed": "{{database}} affiche les lignes qui la référencent.",
      "twoWayOn": "La base de données affiche les lignes qui la référencent.",
      "twoWayOffNamed": "Une colonne de {{database}} qui renvoie vers celle-ci.",
      "twoWayOff": "Une colonne de la base de données qui renvoie vers celle-ci."
    },
    "richText": {
      "formatting": "Mise en forme",
      "formattingHint": "Titres, listes, gras… Désactivée : texte brut",
      "maxCellLines": "Lignes dans le tableau"
    },
    "options": {
      "color": "Couleur de l'option",
      "name": "Nom de l'option",
      "reorder": "Réordonner",
      "delete": "Supprimer l'option",
      "descriptionPlaceholder": "Ajouter une description pour Nolë…",
      "description": "Description de l'option",
      "add": "Ajouter une option"
    }
  },
  "fieldEditors": {
    "emailPlaceholder": "nom@exemple.com",
    "date": {
      "rangePlaceholder": "Demain → vendredi prochain",
      "placeholder": "Demain, 23/10, lundi prochain 14h…",
      "startTime": "Heure de début",
      "endTime": "Heure de fin"
    },
    "file": {
      "uploadFailed": "L'import a échoué.",
      "remove": "Retirer {{name}}",
      "upload": "Importer un fichier",
      "replace": "Remplacer le fichier"
    },
    "node": {
      "unavailable": "Node indisponible"
    },
    "relation": {
      "linked": "Liées",
      "rows": "Lignes",
      "noDatabase": "Choisissez la base de données liée par cette relation, dans les réglages de la colonne."
    },
    "options": {
      "searchOrCreate": "Rechercher ou créer une option",
      "search": "Rechercher une option",
      "create": "Créer <pill></pill>",
      "none": "Aucune option"
    },
    "empty": "Vide",
    "required": "obligatoire"
  },
  "layout": {
    "emptyText": "Texte vide",
    "unknownField": "Champ inconnu"
  },
  "inlineEdit": {
    "placeholder": "Cliquez pour modifier…"
  }
}
